import { getOSM } from '../OverworldAnimation.js';
import Boundary from './Boundary.js';
import { OVERWORLD_EVENT } from '../constants.ts';

export const ETT_ON_ENTER = 'on_enter';
export const ETT_ON_EXIT = 'on_exit';
export const ETT_ON_INTERACT = 'on_interact';
export const ETT_ON_TIMED = 'on_timed';
export const ETT_ON_LOCATION = 'on_location';
export const ETT_ON_MAP = 'on_map';
export const ETT_ON_MAP_EXIT = 'on_map_exit';
export const ETT_ON_MAP_ENTER = 'on_map_enter';
export default class EventTrigger extends Boundary {
    constructor({ eventIdentifier, identifier, position, type = ETT_ON_ENTER }) {
        super({ position });
        this.eventIdentifier = eventIdentifier;
        this.identifier = identifier;
        this.position = position;
        this.width = 16;
        this.height = 16;
        this.visible = true;
        this.type = type;
        this.interactionPriority = 10;
    }

    serialize() {
        console.log('Serializing EventTrigger');
        return {
            eventIdentifier: this.eventIdentifier,
            identifier: this.identifier,
            position: this.position,
        };
    }

    static deserialize(data) {
        return new EventTrigger({
            eventIdentifier: data.eventIdentifier,
            identifier: data.identifier,
            position: data.position,
            type: data.type,
        });
    }

    entered() {
        const playerPosition = getOSM().player.position;
        if (getOSM().skipEvents) {
            return false;
        }
        return playerPosition.x === this.position.x && playerPosition.y === this.position.y;
    }

    getEvent() {
        return getOSM().currentMap.events.find((event) => event.identifier === this.eventIdentifier);
    }

    canInteract() {
        const event = getOSM().currentMap.events.find((event) => event.identifier === this.eventIdentifier);
        if (!event) return false;
        if (!event.isActive) return false;
        if (event.complete) return false;
        if (this.type === ETT_ON_INTERACT) {
            return true;
        }
        return false;
    }

    interact() {
        if (this.canInteract()) {
            getOSM().context.currentEvent = getOSM().currentMap.events.find(
                (event) => event.identifier === this.eventIdentifier
            );
            getOSM().stateQueue.push(OVERWORLD_EVENT);
        }
    }

    draw() {
        // c.fillStyle = 'rgba(255, 0, 255, 1)';
        // c.fillRect(this.effectivePosition().x, this.effectivePosition().y, this.width, this.height);
    }
}
